import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-view container d-flex justify-content-center py-4 py-md-5" }
const _hoisted_2 = { class: "col-12 col-lg-11 col-xl-9 col-xxl-7" }
const _hoisted_3 = { class: "form" }

import PageHero from "@/components/misc/PageHero.vue";
import RegisterForm from "@/components/forms/RegisterForm.vue";
import { useHead } from "@unhead/vue";
// import { useAuthStore } from "@/stores/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterView',
  setup(__props) {

useHead({
  title: "Register",
});

// const authStore = useAuthStore();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageHero, {
        eyebrow: "Vasco Mobile",
        title: "Create your account",
        subtitle: "Have your cellphone number and your order reference ready. It takes a few minutes."
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(RegisterForm)
      ])
    ])
  ]))
}
}

})